import { PageMenu } from 'components/ideal-core-ui'

const MENU = [
  {
    key: 'sales',
    text: 'Sales Reports',
    submenu: [
      {
        key: 'sales-and-forecast',
        path: 'sales/sales-and-forecast',
        text: 'YTD + Annual Sales & Forecast Report'
      },
      {
        key: 'anual-opportunities-sold',
        path: 'sales/anual-opportunities-sold',
        text: 'YTD + Anual Opportunities Sold'
      },
      {
        key: 'anual-submitted-bids',
        path: 'sales/anual-submitted-bids',
        text: 'YTD + Annual Submitted Bids'
      },
      {
        key: 'opportunities-by-internal-team-role',
        path: 'sales/opportunities-by-internal-team-role',
        text: 'Opportunities by Internal Team Role'
      },
      {
        key: 'opportunities-in-forecast',
        path: 'sales/opportunities-in-forecast',
        text: 'Opportunities in Forecast'
      },
      {
        key: 'opportunity-bid-due-date',
        path: 'sales/opportunity-bid-due-date',
        text: 'Opportunities by Bid Due Date'
      },
      {
        key: 'opportunity-creation-date',
        path: 'sales/opportunity-creation-date',
        text: 'Opportunities by Creation Date'
      },
      {
        key: 'opportunity-bid-submission-date',
        path: 'sales/opportunity-bid-submission-date',
        text: 'Opportunities by Submission Date'
      },
      {
        key: 'opportunity-bid-submission-status',
        path: 'sales/opportunity-bid-submission-status',
        text: 'Opportunities by Submission Status'
      },
      {
        key: 'opportunity-follow-up-date',
        path: 'sales/opportunity-follow-up-date',
        text: 'Opportunities by FollowUp Date'
      },
      {
        key: 'opportunity-won-date',
        path: 'sales/opportunity-won-date',
        text: 'Opportunities by Won Date'
      },
      {
        key: 'opportunity-lost-date',
        path: 'sales/opportunity-lost-date',
        text: 'Opportunities by Lost Date'
      },
      {
        key: 'opportunity-source',
        path: 'sales/opportunity-source',
        text: 'Opportunities by Source'
      },
      {
        key: 'opportunity-scope',
        path: 'sales/opportunity-scope',
        text: 'Opportunities by Scope'
      },
      {
        key: 'opportunity-priority',
        path: 'sales/opportunity-priority',
        text: 'Opportunities by Priority'
      },
      {
        key: 'opportunity-by-visibility',
        path: 'sales/opportunity-by-visibility',
        text: 'Opportunities by Public/Private'
      },
      {
        key: 'opportunity-by-category',
        path: 'sales/opportunity-by-category',
        text: 'Opportunities by Category'
      },
      {
        key: 'opportunity-client-bid-stage',
        path: 'sales/opportunity-client-bid-stage',
        text: 'Opportunities by Client Bid Stage'
      },
      {
        key: 'opportunity-reason-for-not-winning',
        path: 'sales/opportunity-reason-for-not-winning',
        text: 'Opportunities by Reason for Not Winning'
      },
      {
        key: 'opportunity-reason-for-not-bidding',
        path: 'sales/opportunity-reason-for-not-bidding',
        text: 'Opportunities by Reason for Not Bidding'
      },
      {
        key: 'opportunity-by-contract-type',
        path: 'sales/opportunity-by-contract-type',
        text: 'Opportunities by Contract Type'
      },
      {
        key: 'opportunity-by-work-type',
        path: 'sales/opportunity-by-work-type',
        text: 'Opportunities by Work Type'
      },
      {
        key: 'opportunity-by-geo-area',
        path: 'sales/opportunity-by-geo-area',
        text: 'Opportunities by Geo Area'
      },
      {
        key: 'opportunity-by-health',
        path: 'sales/opportunity-by-health',
        text: 'Opportunities by Health'
      },
      {
        key: 'opportunity-by-quote-number',
        path: 'sales/opportunity-by-quote-number',
        text: 'Opportunities by Quote Number'
      },
      {
        key: 'opportunity-size',
        path: 'sales/opportunity-size',
        text: 'Opportunities by Size'
      },
      {
        key: 'opportunity-by-project-number',
        path: 'sales/opportunity-by-project-number',
        text: 'Opportunities by Project Number'
      },
      {
        key: 'opportunity-by-start-end-date',
        path: 'sales/opportunity-by-start-end-date',
        text: 'Opportunities by Start and End Dates'
      },
      {
        key: 'opportunity-by-project-type',
        path: 'sales/opportunity-by-project-type',
        text: 'Opportunities by Project Type'
      },
      {
        key: 'margin-analysis',
        path: 'sales/margin-analysis',
        text: 'Margin Analysis Report'
      }
    ]
  },
  {
    key: 'pipeline',
    text: 'Pipeline Reports',
    submenu: [
      {
        key: 'pipeline-by-stage',
        path: 'pipeline/pipeline-by-stage',
        text: 'Pipeline by Stage'
      },
      {
        key: 'pipeline-by-client',
        path: 'pipeline/pipeline-by-client',
        text: 'Pipeline by Client'
      },
      {
        key: 'pipeline-by-location',
        path: 'pipeline/pipeline-by-location',
        text: 'Pipeline by Location'
      }
    ]
  },
  {
    key: 'team',
    text: 'Team Sales Reports',
    submenu: [
      {
        key: 'pipeline-by-user',
        path: 'team/pipeline-by-user',
        text: 'Pipeline by User'
      }
    ]
  }
]

const Menu = ({ page, setPage, category, withSearch }) => {
  return (
    <PageMenu
      page={page}
      setPage={setPage}
      menu={MENU}
      subPageOpened={category}
      withRoutes
      sticky
      withSearch={withSearch}
    />
  )
}

export default Menu
